import {Injectable} from '@angular/core';
import {BaseDao} from '../../../base-dao';
import {R2CloudHttpApiService} from '../../../r2-cloud-http-api.service';
import {KluhManagerValidator} from '../../../validators/kluh-manager-validator';
import {Observable} from 'rxjs/internal/Observable';
import {of} from 'rxjs/internal/observable/of';
import {GatewayServer, GatewayServerWithPassword, GuacServer, GuacServerInUse} from '../../../models';


@Injectable()
export class GuacServerDaoService extends BaseDao<GuacServer> {

    constructor(http: R2CloudHttpApiService, validatorDAO: KluhManagerValidator) {
        super(http, validatorDAO, 'guac-server');
    }


    initGuacServer(): GuacServer {
        return {
            id: null,
            name: null,
            secretKey: null,
            comment: null,
            active: true,
            modified: null,
            optlock: null,
            fqdn: null,
            port: null,
            path: null,
            customerGroupId: null,
            createdAt: null,
            updatedAt: null,
        };
    }

    findAllBy(customerGroupId: number): Observable<GuacServer[]> {
        if (!customerGroupId) {
            return of();
        }
        return this.http.get<GuacServer[]>(this.url + '/find-all-by/' + customerGroupId);
    }


    checkIfCanCreate(guacServer: GuacServer): Observable<boolean> {
        return this.http.post<boolean>(this.url + '/check-if-can-create/', guacServer);
    }

    canDelete(guacServerId: number): Observable<boolean> {
        return this.http.get<boolean>(this.url + '/can-delete/' + guacServerId);
    }

    findWhereGuacServerInUse(guacServer: GuacServer): Observable<GuacServerInUse[]> {
        return this.http.post<GuacServerInUse[]>(this.url + '/find-where-guac-server-in-use/', guacServer);
    }
}
